module.exports = __webpack_public_path__ + "static/media/add.bb144ff6.svg";